<template>
  <main id="app">
    <div v-if="!$route.matched.length">
      <div class="container text-center">
        <img alt="Vue logo" src="https://vuejs.org/images/logo.png" style="max-height: 2em;" v-bind:title="message">
      </div>
      <DynamicTable />
    </div>
    <router-view v-else />
  </main>
</template>

<script>
import DynamicTable from './components/DynamicTable.vue'

export default {
  name: 'App',
  components: {
    DynamicTable
  },
  data: () => {
    return {
      message: 'You loaded this page on ' + new Date().toLocaleString()
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
